import { render, staticRenderFns } from "./FiltersChips.vue?vue&type=template&id=0bc35b53&scoped=true"
import script from "./FiltersChips.vue?vue&type=script&lang=js"
export * from "./FiltersChips.vue?vue&type=script&lang=js"
import style0 from "./FiltersChips.vue?vue&type=style&index=0&id=0bc35b53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc35b53",
  null
  
)

export default component.exports